import * as React from 'react';
import { makeStyles } from '@mui/styles';
import { List, ListItem, Typography, ListItemText } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ConnectorInfo } from 'types/types';

const useStyles = makeStyles((theme) => ({
  listItem: {
    display: 'list-item',
    padding: theme.spacing(0)
  },
  heading: {
    fontSize: theme.spacing(2.5),
    paddingTop: theme.spacing(2)
  },
  description: {
    fontFamily: theme.typography.fontFamily
  },
  container: { maxWidth: '65%' }
}));

type DescriptionTextProps = {
  info: ConnectorInfo;
};

export const DescriptionText: React.FC<DescriptionTextProps> = ({
  info
}: DescriptionTextProps) => {
  const classes = useStyles();

  return (
    <div data-testid="all-text-renders" className={classes.container}>
      <Typography className={classes.heading} data-testid="aboutText">
        <FormattedMessage id="connectorDescription.about" />
      </Typography>
      <Typography
        className={classes.description}
        data-testid="aboutDescription"
      >
        <FormattedMessage
          id={'connectorDescription.aboutDescription'}
          values={{ connectorName: info.name }}
        />
      </Typography>
      <Typography className={classes.heading} data-testid="workflowsText">
        <FormattedMessage id="connectorDescription.workflows" />
      </Typography>
      <List
        sx={{
          listStyleType: 'disc',
          pl: 2,
          '& .MuiListItem-root': {
            display: 'list-item'
          }
        }}
        dense={true}
        style={{ paddingTop: '10px' }}
        data-testid={'connectors-description-lists'}
      >
        {info.descriptionTextArray.length &&
          info.descriptionTextArray.map((text, index) => (
            <ListItem key={index} className={classes.listItem}>
              <ListItemText
                primary={
                  <Typography className={classes.description}>
                    {text}
                  </Typography>
                }
              />
            </ListItem>
          ))}
      </List>
    </div>
  );
};
